export const routes = {
  home: () => "/",
};
